import ApiClient from './ApiClient';

class CloseCircleMembersAPI extends ApiClient {
  constructor() {
    super('close_circle_members', { accountScoped: true });
    this.contactId = null;
  }

  get url() {
    return `${this.baseUrl()}/contacts/${this.contactId}/close_circle_members`;
  }

  get(contactId) {
    this.contactId = contactId;
    return super.get();
  }

  show(contactId, memberId) {
    this.contactId = contactId;
    return super.show(memberId);
  }

  create(contactId, data) {
    this.contactId = contactId;
    return super.create({ close_circle_member: data });
  }

  update(contactId, memberId, data) {
    this.contactId = contactId;
    return super.update(memberId, { close_circle_member: data });
  }

  delete(contactId, memberId) {
    this.contactId = contactId;
    return super.delete(memberId);
  }
}

export default new CloseCircleMembersAPI();
